const prodServiceEndpointsConfig = {
    wwwDomainToEnvMap: [{ from: 'www.onshape.com', to: 'live' }],
    wwwEnvToCadEnvMap: [{ from: 'live', to: 'live' }],
    cadEnvToCadDomainMap: [{ from: 'live', to: 'cad.onshape.com' }],
    cadEnvToCadSsoDomainMap: [{ from: 'live', to: 'sso.onshape.com' }],
    firebaseDevFunctionsMap: [],
};
export default prodServiceEndpointsConfig;
